import React from 'react'

const CardWithImage = ({image, title, description}) => {
  return (
    <div className='w-[375px] relative flex items-center '>
        <img src={image} alt="AboutPic" className='w-full object-cover rounded-3xl'/>
        <div className='absolute flex items-start justify-center flex-col text-white bg-primary bg-opacity-50 pl-7 w-full h-full rounded-3xl'>
        <h1 className='border-b-2 border-white p-1 text-xl font-extrabold'>{title}</h1>
        <p className={`p-2 bg-primary bg-opacity-20 rounded-lg w-[325px] font-semibold overflow-auto text-left`}>
           {description}
        </p>
        </div>
    </div>
  )
}

export default CardWithImage
